import React, { Component } from 'react';
import Moment from 'react-moment';
import {ApiBaseUrl} from '../../constants';
import { AuthContext } from "./../../context/auth";
import {withSnackbar} from "react-simple-snackbar";
import {trackPromise} from "react-promise-tracker";

class RatedReviewDetail extends Component{
    static contextType = AuthContext;
    state = {
        rating:0,
        feedback:''
    }

    handleNameChange = (event) => {
        const {name,value} = event.target;
        this.setState({
            [name] : value
        })
    }

    handleRating = (event) => {
        this.setState({
            rating: event.target.value
        })
    }

    submitHandler = (event) => {
        event.preventDefault()
        if(this.state.rating === 0) {
            this.props.openSnackbar('Please enter rating')
            return
        }
        let formBody = "rating="+ encodeURIComponent(this.state.rating)+'&feedback='+encodeURIComponent(this.state.feedback);
        trackPromise(
        fetch(ApiBaseUrl + "/consumer/rate_deal/"+this.props.location.state.deal._id,
            {
                method: 'POST',
                body: formBody,
                headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(!result.success)
                        this.props.openSnackbar(result.message)
                    else{
                        this.props.history.replace({ pathname: process.env.PUBLIC_URL+'/reviews/rated/'});
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    componentDidMount() {
        if(!this.props.location.state)
            this.props.history.replace({ pathname: process.env.PUBLIC_URL+'/reviews/pending/'});
        window.scrollTo(0, 0)
    }

    render() {
        return (
            this.props.location.state ?
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 px--xs-0">
                            <div className="all-categories-outer feedback-wrapper">
                                <div className="each-category-outer">
                                    <div className="row">
                                        <div className="col-lg-4 col-xl-3 spacing-all-category">
                                            <div className="category-box-outer p-0 border-grey">
                                                <div className="category-box-header h-md">
                                                    <img src={this.props.location.state.deal.image} alt={this.props.location.state.deal.name}/>
                                                </div>
                                                <div className="category-box-body">
                                                    <h1 className="date-01"><span><Moment format="DD" parse="DD-MM-YYYY">
                                                        {this.props.location.state.deal.purchased_for_date ? this.props.location.state.deal.purchased_for_date : this.props.location.state.deal.dealdate}
                                                            </Moment></span><span> <Moment format="MMM" parse="DD-MM-YYYY">
                                                                {this.props.location.state.deal.purchased_for_date ? this.props.location.state.deal.purchased_for_date : this.props.location.state.deal.dealdate}
                                                            </Moment></span></h1>
                                                    <div className="deal_rating_sec">
                                                        <h4 className="category-box-body-title custom-height">{this.props.location.state.deal.category.name}</h4>
                                                        <p className="category-box-body-subtitle custom-height">{this.props.location.state.deal.name}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-xl-9">
                                            <div className="feedbackform-outer">
                                                <form autoComplete="off" onSubmit={this.submitHandler}>
                                                    <div className="allstar-outer d-flex">
                                                        <h6 className="text-white mr-1">Rate the deal -</h6>
                                                        <div className="custom-feedback">
                                                            <div className="rating">
                                                                <input type="radio" name="rating" value="5" onClick={this.handleRating} id="rating-5"/>
                                                                <label htmlFor="rating-5"></label>
                                                                <input type="radio" name="rating" value="4" onClick={this.handleRating} id="rating-4"/>
                                                                <label htmlFor="rating-4"></label>
                                                                <input type="radio" name="rating" value="3" onClick={this.handleRating} id="rating-3"/>
                                                                <label htmlFor="rating-3"></label>
                                                                <input type="radio" name="rating" value="2" onClick={this.handleRating} id="rating-2"/>
                                                                <label htmlFor="rating-2"></label>
                                                                <input type="radio" name="rating" value="1" onClick={this.handleRating} id="rating-1"/>
                                                                <label htmlFor="rating-1"></label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="ratingrow-outer">
                                                        <p className="green-color">Give your feedback here :</p>
                                                        <textarea className="feedback--area" name="feedback" id="" onChange={this.handleNameChange} value={this.state.feedback} placeholder="Your feedback"></textarea>
                                                    </div>
                                                    <input type="submit" value="submit" className="feedback--btn"/>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                : null
        )
    }
}

export default withSnackbar(RatedReviewDetail,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});